import React from 'react';
import { StarIcon } from 'lucide-react';
import { BundleMockup } from './BundleMockup';
import { CtaButton } from './CtaButton';
export function Hero() {
  return <header className="px-4 pb-16 pt-10 sm:px-5 md:pb-20 md:pt-20" data-id="element-103" data-mp="ei1vfm5pk2xy">
      <div className="mx-auto max-w-5xl text-center" data-id="element-104" data-mp="9lbeyxpzr5c0">
        <p className="mx-auto flex max-w-xs items-center justify-center gap-3 text-[10px] font-semibold uppercase leading-relaxed tracking-[0.18em] text-gold sm:max-w-none sm:gap-4 sm:text-[11px] sm:tracking-[0.25em]" data-id="element-105" data-mp="4m8n6ez0uvlz">
          <span className="hidden h-px w-8 bg-gold/70 sm:block" data-id="element-106" data-mp="xbfmhg6avp8a" />
          La méthode complète pour les professeurs de guitare jazz
        </p>
        <h1 className="mt-6 font-display text-[2.6rem] uppercase leading-[0.95] text-cream sm:mt-8 sm:text-7xl md:text-8xl" data-id="element-107" data-mp="sddz4j1ud3r0">
          Organisez tout votre
          <br data-id="element-108" data-mp="3d2l8d8tzsyz4" />
          <span className="text-gold" data-id="element-109" data-mp="3d33eqyadctkr">trimestre de jazz avec ce pack</span>
        </h1>
        <p className="mx-auto mt-6 max-w-2xl font-serif text-lg italic leading-relaxed text-cream/90 sm:mt-8 sm:text-xl md:text-2xl" data-id="element-110" data-mp="381nv9anuav4h">
          Le système « Imprimez & Enseignez » pour les professeurs de guitare jazz qui transforme la
          préparation de vos cours de <span className="text-gold" data-id="element-111" data-mp="39al8kaui8i1k">chaotique</span> en{' '}
          <span className="text-cream" data-id="element-112" data-mp="39cflb1vmh3uk">évidente</span>.
        </p>
      </div>

      <div className="mt-10 sm:mt-14" data-id="element-113" data-mp="3e84rvp627l0d">
        <BundleMockup data-id="element-114" data-mp="30i18d5yke5em" />
      </div>

      <div className="mt-10 flex flex-col items-center gap-4 sm:mt-12" data-id="element-115" data-mp="30hre366hlc34">
        <CtaButton data-id="element-116" data-mp="358hlsq2dxr0z" />
        <div className="flex flex-col items-center gap-1.5 text-center text-sm text-cream-muted sm:flex-row sm:gap-2" data-id="element-117" data-mp="358zq89z7bbjz">
          <span className="flex text-gold" aria-hidden="true" data-id="element-118" data-mp="2ql69glydq2zt">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" data-id="element-119" data-mp="2vj7sj6vt22ba" data-mpi={i} />)}
          </span>
          Adopté par plus de 1 200 professeurs · Accès immédiat
        </div>
      </div>
    </header>;
}